import { ALL_PRODUCT_TYPES } from "constants/chart.constants";
import { getProductType } from "utils";

import { IGroupByListColumn } from "models";

const filterByProduct = (
  product: string,
  columns: IGroupByListColumn[]
): IGroupByListColumn[] => {
  if (!product) return columns;

  const productObject = getProductType(product);
  const { key, label } = productObject;

  return columns.filter(
    (column) =>
      column.product === key ||
      column.product === label ||
      // Backend sends "On Time"
      (key === ALL_PRODUCT_TYPES.OnTime.key && column.product === "On Time")
  );
};

export default filterByProduct;
